var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#00BCD4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3332 23.7084C24.3332 24.05 24.0498 24.3334 23.7082 24.3334H8.2915C7.94984 24.3334 7.6665 24.05 7.6665 23.7084C7.6665 23.3667 7.94984 23.0834 8.2915 23.0834H23.7082C24.0498 23.0834 24.3332 23.3667 24.3332 23.7084Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.826 9.76806L9.87601 18.718C9.53434 19.0597 8.98434 19.0597 8.65101 18.718H8.64268C7.48434 17.5514 7.48434 15.668 8.64268 14.5097L14.601 8.55139C15.7677 7.38472 17.651 7.38472 18.8177 8.55139C19.1593 8.87639 19.1593 9.43473 18.826 9.76806Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3513 13.0753L20.8097 10.5336C20.468 10.1919 19.918 10.1919 19.5847 10.5336L10.6347 19.4836C10.293 19.8169 10.293 20.3669 10.6347 20.7086L13.1763 23.2586C14.343 24.4169 16.2263 24.4169 17.393 23.2586L23.343 17.3003C24.5263 16.1336 24.5263 14.2419 23.3513 13.0753ZM16.6347 20.6003L15.6263 21.6169C15.418 21.8253 15.0763 21.8253 14.8597 21.6169C14.6513 21.4086 14.6513 21.0669 14.8597 20.8503L15.8763 19.8336C16.0763 19.6336 16.4263 19.6336 16.6347 19.8336C16.843 20.0419 16.843 20.4003 16.6347 20.6003ZM19.943 17.2919L17.9097 19.3336C17.7013 19.5336 17.3597 19.5336 17.143 19.3336C16.9347 19.1253 16.9347 18.7836 17.143 18.5669L19.1847 16.5253C19.3847 16.3253 19.7347 16.3253 19.943 16.5253C20.1513 16.7419 20.1513 17.0836 19.943 17.2919Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.4713b0e800116f0c758f118844e491da.svg";
export { ForwardRef as ReactComponent };